applications.service('ApplicationService', function($q, $location, RestService, SliderService){
    var awardData;
    var familyNo = 0;
    var loadingApplication = true;
    var nextApplicationClicked = false;
    var applicationID;
    var openNote = false;
    var openTD = false;

    var getFamilyNo = function() //Used for Array Indicies , ie Family one is family[0]
    {
        return familyNo;
    }
    var isFamilyTwoSituation = function()
    {
        if (typeof awardData != "undefined")
        {
            if (awardData.family.length == 1)
                return false;
            else if (awardData.family[1].data==undefined)
                return false;
            else if (awardData.family[1].data[0].Fam_Guard_Excuse)
                return false;  
            else
                return awardData.family.length > 1;
        }
    }
    var isFamilyTwoExcuseSituation = function() {
        if (typeof awardData != "undefined")
        {
            if (awardData.family.length==2 && awardData.family[1].data[0].Fam_Guard_Excuse)
                return true;
            else
                return false;
        }
        return false;
    }
    var getFamCount = function()
    {
        var FamCount = 1;
        if (isFamilyTwoSituation())
            FamCount = 2;
        return FamCount;
    }

    var getOpenNote = function()
    {
        return openNote 
    }

    var setOpenNote = function(open)
    {
        openNote = open;
    }

    var getChildrenWithTuition = function(familyNo)
    {
        if (familyNo === undefined )
            familyNo = getFamilyNo();

        var result = [];
        for (var i = 0; i < awardData.family[familyNo].children.length; i++)
        {
            if (awardData.family[familyNo].children[i].Chi_Tuition_Amt > 0)
                result.push(awardData.family[familyNo].children[i]);
        }
        return result;
    }

    var getDepsWithTuition = function(familyNo)
    {
        if (familyNo === undefined )
            familyNo = getFamilyNo();

        var result = [];
        for (var i = 0; i < awardData.family[familyNo].dependant.length; i++)
        {
            if (awardData.family[familyNo].dependant[i].Dep_Tuition_Amt > 0)
                result.push(awardData.family[familyNo].dependant[i]);
        }
        return result;
    }

    var getData = function(appID)
    {
        awardData = undefined;
        applicationID = undefined;
        loadingApplication = true;
        var td = RestService.get('/api/TruthDetector/' + appID + '/detect');
        var ad = RestService.get("/api/awardData/" + appID);
        return $q.all([ad, td]).then(function(results) {
            awardData = results[0].data;
            awardData.td = results[1].data;
            loadingApplication = false;
            applicationID = appID;
            openTD = false;
        });
    }

    var getIncomeLabel = function () {
        if (awardData.family[familyNo].data[0].Fam_Country === "Canada") {
            return "T-4 Income";
        } else if (awardData.family[familyNo].data[0].Fam_Country === "United States") {
            return "W2 Income";
        } else {
            return "Annual Income";
        }
    }

    return {
        getData: getData,
        getAwardData: function()
        {
            return awardData;
        },
        getFamilyData: function(familyIndex)
        {
            if (typeof familyIndex === 'undefined')
                return awardData.family[familyNo];
            else
                return awardData.family[familyIndex];
        },
        getFamilyNo: getFamilyNo,
        setFamilyNo: function(index)
        {
            familyNo = index;
        },
        hasFamilyHome: function(familyIndex)
        {
            familyIndex = getFamilyNo();
            if (typeof familyIndex === 'undefined')
                familyIndex = 0;
            var real_estate = awardData.family[familyIndex].real_estate;
            for (var i = 0; i < real_estate.length; i++)
            {
                if (real_estate[i].Rea_Description == "Family Home")
                    return true;
            }
            return false;
        },
        getFamilyIndex: function(familyID)
        {
            if (awardData.family[0].data[0].familyID == familyID)
                return 0;
            else if (typeof awardData.family[1] != 'undefined' && awardData.family[1].data[0].familyID == familyID)
                return 1;
            else
                return -1;
        },
        getFamilyID: function(familyIndex)
        {
            if (typeof familyIndex === 'undefined')
                return awardData.family[familyNo].data[0].familyID;
            else
                return awardData.family[familyIndex].data[0].familyID;
        },
        isFamilyTwoSituation: isFamilyTwoSituation,
        getApplicationID: function()
        {
            return applicationID;
        },
        getLoadingApplication: function()
        {
            return loadingApplication;
        },
        setLoadingApplication: function(value)
        {
            loadingApplication = value;
        },
        isFamilyTwoExcuseSituation: isFamilyTwoExcuseSituation,
        getChildrenWithTuition: getChildrenWithTuition,
        getDepsWithTuition: getDepsWithTuition,
        getFamCount: getFamCount,
        setOpenNote: setOpenNote,
        getOpenNote: getOpenNote,
        nextApplicationClicked: nextApplicationClicked,
        clear: function()
        {
            applicationID = undefined;
            loadingApplication = false;
            SliderService.closeSlider();
        },
        getIncomeLabel: getIncomeLabel
    }
});